export default __webpack_public_path__ + "static/media/faq.5121e2f4.jpg";